import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import FetchModule from '../../../../Share/Network/FetchModule';
import moment from 'moment';
import { useLanguage } from '../../../../../Context/LanguageContext';

export default function MembershipSubscriptionCancelModal(props) {
  const { memberName, data, index, className, onClickClose, rendering } = props;
  const { t } = useLanguage();

  const [membershipName, setMembershipName] = useState('');
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [totalPrice, setTotalPrice] = useState(0);

  const history = useHistory();

  useEffect(() => {
    document.body.style= `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  useEffect(() => {
    if (index === -1) return;

    setMembershipName(data[index].memberShipName);
    setStartDate(moment(data[index].startDate));
    setEndDate(moment(data[index].endDate));
    setTotalPrice(data[index].totalPrice.toLocaleString('ko-KR'));
  }, [data, index])

  function onClickCancel() {
    let requestData = {
      merchantUid: data[index].merchantUid
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/cancel/subscribe/', 'POST', requestData);
       
        if (responseData.status === 200) {
          alert(t('memberDetail.subCancelModal.alertSubCancelled'));
          onClickClose(className);
          rendering();
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          history.push('/');
        }
        else {
          alert(responseData.error);
          return;
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <ModalView>
        <TotalWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>{memberName + t('memberDetail.subCancelModal.subCancelTitle')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#777777' cursor='default'>{t('memberDetail.subCancelModal.subCancelDesc')}</Text>
          <MembershipInfoWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={100}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.subCancelModal.subCancelMembershipName')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={242}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{membershipName}</Text>
              </MembershipTextWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={100}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.subCancelModal.subCancelPeriod')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={242}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{startDate.format('YYYY.MM.DD') + ' ~ ' + endDate.format('YYYY.MM.DD')}</Text>
              </MembershipTextWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={100}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.subCancelModal.subCancelNextPayDate')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={242}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{endDate.format('YYYY.MM.DD')}</Text>
              </MembershipTextWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={100}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.subCancelModal.subCancelPayAmount')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={242} style={{ gap: '4px' }}>
                <LinkoPayBox>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>{t('memberDetail.subCancelModal.subCancelLinkoPay')}</Text>
                </LinkoPayBox>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{totalPrice}</Text>
              </MembershipTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.subCancelModal.subCancelWon')}</Text>
            </LayerWrapper>
          </MembershipInfoWrapper>
          <ExplanationWrapper>
            <LayerWrapper style={{ gap: '4px' }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.subCancelModal.subCancelWarning1')}</Text>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#D92828' cursor='default'>{t('memberDetail.subCancelModal.subCancelWarning2')}</Text>
            </LayerWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.subCancelModal.subCancelWarning3')}</Text>
          </ExplanationWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickClose}>{t('memberDetail.modalCancel')}</ExitButton>
            <SubscriptionCancelButton onClick={onClickCancel}>{t('memberDetail.subCancelModal.subCancelBtn')}</SubscriptionCancelButton>
          </ButtonWrapper>
        </TotalWrapper>
      </ModalView>
    </TopLevelWrapper> 
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 425px;
  height: 414px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 385px;
`;

const MembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-bottom: 24px;
  margin-top: 30px;

  width: 100%;

  gap: 25px;

  border-bottom: 1px solid #B2B2B2;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const MembershipTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: ${props => props.width}px;
  height: 21px;

  overflow: hidden;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: 14px;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  gap: 14px;

  width: 100%;
`;

const LinkoPayBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;

  border-radius: 5px;
  background-color: #6DD49E;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;
  
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #3E4148;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SubscriptionCancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #5BD98A;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;